import type React from "react";
import { twJoin } from "tailwind-merge";

import { tooltipSurfaceClassName } from "@/design-system/TooltipSurface";
import type { InputTooltipFloating } from "@/ui-adapters/useInputTooltipFloating";

export function InputTooltip({
  tooltip,
  children,
}: {
  children: React.ReactNode;
  tooltip: InputTooltipFloating;
}): React.ReactNode {
  return (
    tooltip.isMounted && (
      <div {...tooltip.floatingProps} role="tooltip" className="z-overlay">
        <div
          {...tooltip.surfaceProps}
          className={twJoin(
            "max-w-tooltip-wide animation-fill-forwards",
            tooltipSurfaceClassName,
            "data-[placement=bottom]:origin-top data-[placement=left]:origin-right data-[placement=right]:origin-left data-[placement=top]:origin-bottom",
            "data-[state=open]:animate-in data-[state=open]:fade-in data-[state=open]:zoom-in",
            "data-[state=closed]:animate-out data-[state=closed]:fade-out data-[state=closed]:zoom-out",
          )}
        >
          <InputTooltipArrow floating={tooltip} />
          {children}
        </div>
      </div>
    )
  );
}

function InputTooltipArrow({ floating }: { floating: InputTooltipFloating }) {
  return (
    <div
      {...floating.arrowProps}
      className="absolute inset-x-0 mx-auto size-tooltip-arrow rotate-45 bg-background-brand-secondary"
      aria-hidden
    />
  );
}
